import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Flex, getPaletteColor, Hide, Box } from 'pcln-design-system'

import Skeleton from '../Skeleton'
import { WidthSkeleton } from '../WidthSkeleton'
import Repeat from '../../Repeat/Repeat'

const WrapperFlex = styled(Flex)`
  background-color: ${({ whiteOnGray, theme }) =>
    whiteOnGray ? getPaletteColor('background.light')({ theme }) : 'transparent'};
  max-width: 1380px;
  width: 100%;
  height: 68px;
  ${(props) => props.theme.mediaQueries.xl} {
    height: ${(props) => props.height};
  }
`

function InputSkeleton(props) {
  return <StyledInput height={'46px'} {...props} />
}

const StyledInput = styled(Skeleton)`
  ${({ white }) => (white ? 'background: #fff;' : '')};
  margin-right: 8px;
`

const StyledWidthSkeleton = styled(WidthSkeleton)`
  ${({ white }) => (white ? 'background-color: #fff;' : '')};
`

export function SearchFormSkeleton({ whiteOnGray, heightOverride }) {
  return (
    <WrapperFlex
      flexDirection={'column'}
      justifyContent={'center'}
      px={1}
      pb={2}
      whiteOnGray={whiteOnGray}
      height={heightOverride}
    >
      <Hide xs sm md lg>
        <Flex flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} mb={'12px'}>
          <Repeat times={3}>
            <StyledWidthSkeleton
              height={'30px'}
              width={'100px'}
              mr={'12px'}
              ml={'12px'}
              disable
              white={whiteOnGray}
            />
          </Repeat>
        </Flex>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} ml={'12px'}>
          {/* Input fields */}
          <Repeat times={4}>
            <InputSkeleton disable white={whiteOnGray} />
          </Repeat>

          {/* Submit button */}
          <Flex width={'140px'} alignItems={'center'} mr={3}>
            <StyledWidthSkeleton height={'46px'} width={'140px'} disable white={whiteOnGray} />
          </Flex>
        </Flex>
      </Hide>
      <Hide xl xxl>
        <Box width='100%' height='68px' py={2} />
      </Hide>
    </WrapperFlex>
  )
}

SearchFormSkeleton.defaultProps = {
  heightOverride: '135px',
}

SearchFormSkeleton.propTypes = {
  whiteOnGray: PropTypes.bool,
  heightOverride: PropTypes.string,
}
